const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/AppBar/AppBar.tsx';
import { AppBar } from 'App/components/AppBar/AppBar';
import { getPatAppSettings } from 'App/utils/generalUtils';
import * as React from 'react';
import { cx } from '@emotion/css';
import {
    logoFrameStyle,
    logoFrameStyleVerticalCenter,
    logoInlineStyle,
    logoStyleSmallDevice,
} from '../../LoginPage/styles';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import { ImageInplaceLoader } from 'App/components/ImageClientLoader/ImageClientLoader';
import { useTheme } from '@mui/material/styles';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';

export const AppBarMain = () => {
    const settings = getPatAppSettings();
    const theme = useTheme();
    const isMediumDevice = useBreakpoint(theme?.breakpoints?.values?.md);
    const { navbarTitle } = getConfiguration();

    const logo = (
        <ImageInplaceLoader className={isMediumDevice ? logoStyleSmallDevice : logoInlineStyle} src={'Logo'} />
    );
    return (
        <AppBar
            primaryText={navbarTitle ? navbarTitle : settings.hospitalLongName}
            logoElement={logo}
            bgndColor={theme.palette.background.paper}
            textColor={theme.palette.primary.main}
            className={cx(logoFrameStyle, isMediumDevice ? logoFrameStyleVerticalCenter : undefined)}
            showLogoutBtn={true}
            showProfileBtn={false}
            showSearchBtn={false}
        />
    );
};
